import { SVGProps } from 'react';

const ActiveBankAccount = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='128'
      height='128'
      viewBox='0 0 128 128'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_703_5643)'>
        <path
          d='M85 112H43C28.1 112 16 99.9 16 85V43C16 28.1 28.1 16 43 16H85C99.8 16 112 28.1 112 43V85C112 99.9 99.9 112 85 112Z'
          fill='#C0F9FC'
        />
        <path
          d='M82 106H45.9C32.1 106 20.9 94.8 20.9 81.1V81C20.9 67.2 32.1 56 45.9 56H82C95.8 56 106.9 67.2 106.9 80.9V81C106.9 94.8 95.8 106 82 106Z'
          fill='#8CE6F4'
        />
        <path
          d='M78.3 30.8002C74.5 29.4002 70.6 28.7002 66.7 28.7002C64.1 28.7002 61.6 29.0002 59 29.6002C50.5 31.6002 43.9 36.3002 38.8 43.5002L38.1 44.4002L37.1 43.9002C35.6 43.2002 34 42.4002 32.4 41.6002L35.5 59.2002L51.1 50.6002C49.8 50.0002 48.5 49.4002 47.2 48.7002L45.6 47.9002L46.8 46.5002C52.1 40.3002 58.7 37.0002 66.5 37.0002L68.7 37.1002C72.9 37.4002 77.1 38.8002 80.6 41.3002C85.6 44.8002 89 49.5002 90.6 55.2002C95.6 54.3002 94.2 54.6002 98.9 53.7002C96.9 45.4002 90.3 35.3002 78.3 30.8002Z'
          fill='#98CB72'
        />
        <path
          d='M76.5 28.9999C72.7 27.5999 68.8 26.8999 64.9 26.8999C62.3 26.8999 59.8 27.1999 57.2 27.7999C48.7 29.7999 42.1 34.4999 37 41.6999L36.3 42.5999L35.3 42.0999C33.8 41.3999 32.2 40.5999 30.6 39.7999L33.7 57.3999L49.3 48.7999C48 48.1999 46.7 47.5999 45.4 46.8999L44 46.2999L45.2 44.8999C50.5 38.6999 57.1 35.3999 64.9 35.3999L67.1 35.4999C71.3 35.7999 75.5 37.1999 79 39.6999C84 43.1999 87.4 47.8999 89 53.5999C94 52.6999 92.6 52.9999 97.3 52.0999C95.1 43.5999 88.6 33.4999 76.5 28.9999Z'
          fill='#B8DD82'
        />
        <path
          d='M70.5 35.1001L76 29.6001C76 29.6001 81.1 31.4001 82.5 33.0001L77.6 37.9001C77.6 37.9001 73.8 35.7001 70.5 35.1001Z'
          fill='#EFFFB7'
        />
        <path
          d='M78.5 38.4001L83.3 33.6001C83.3 33.6001 84.8 34.4001 85.8 35.4001L80.9 40.4001C81 40.4001 79.9 38.8001 78.5 38.4001Z'
          fill='#EFFFB7'
        />
        <path
          d='M85.4 78.6004L43.2 81.0004C40.2 81.2004 37.6 78.9004 37.5 75.9004L36.3 54.6004C36.1 51.5004 38.5 48.8004 41.6 48.6004L80.5 46.4004C85.4 46.1004 89.6 49.9004 89.9 54.8004L90.9 72.6004C91.1 75.7004 88.6 78.4004 85.4 78.6004Z'
          fill='#2891B5'
        />
        <path
          d='M87 77.2002L44.4 79.6002C41.4 79.8002 38.8 77.5002 38.7 74.5002L37.5 52.9002C37.3 49.9002 39.6 47.4002 42.6 47.2002L85.2 44.8002C88.2 44.6002 90.8 46.9002 90.9 49.9002L92.1 71.5002C92.3 74.5002 90 77.0002 87 77.2002Z'
          fill='#3EAFCE'
        />
        <path
          d='M48.8 77.5002L45 77.7002C42.9 77.8002 41 76.2002 40.9 74.1002L39.7 53.0002C39.6 50.9002 41.2 49.0002 43.3 48.9002L82.6 46.7002L48.8 77.5002Z'
          fill='#5DCEE8'
        />
        <path
          d='M87.4 52.5L41.4 55.1L41.6 59L87.6 56.4L87.4 52.5Z'
          fill='white'
        />
        <path
          d='M87 65.7001L82.4 66.0001C81.8 66.0001 81.2 65.6001 81.2 64.9001L81 60.6001C81 60.0001 81.4 59.4001 82.1 59.4001L86.7 59.1001C87.3 59.1001 87.9 59.5001 87.9 60.2001L88.1 64.5001C88.1 65.1001 87.6 65.7001 87 65.7001Z'
          fill='#F6C957'
        />
        <path
          d='M82 79C83.3 79.6 84.5 80.2 85.8 80.8L87.4 81.5L86.3 83C82 88.5 75 92.6 66.6 92.6L63.7 92.5C59.3 92 55.3 90.4 51.7 87.8C46.7 84.1 43.6 79 42.1 73C37.1 73.5 38.4 73.4 33.7 73.8C35.3 83.1 42.3 94.3 55 99C58.8 100.4 62.7 101.1 66.6 101.1C69.1 101.1 71.6 100.8 74.2 100.2C82.8 98.2 89.4 93.5 94.5 86.3L95.2 85.4L96.2 85.9C97.8 86.6 99.3 87.4 100.9 88.1L97.8 70.5L82 79Z'
          fill='#98CB72'
        />
        <path
          d='M80.3 77.2998C81.6 77.8998 82.8 78.4998 84.1 79.0998L85.7 79.7998L84.6 81.1998C80.3 86.6998 73.3 90.7998 64.9 90.7998L62 90.6998C57.6 90.1998 53.6 88.5998 50 85.9998C45 82.2998 41.9 77.1998 40.4 71.1998C35.4 71.6998 36.7 71.5998 32 71.9998C33.5 81.3998 40.5 92.5998 53.1 97.2998C56.9 98.6998 60.8 99.3998 64.7 99.3998C67.2 99.3998 69.7 99.0998 72.3 98.4998C80.9 96.4998 87.5 91.7998 92.6 84.5998L93.3 83.6998L94.3 84.1998C95.9 84.8998 97.4 85.6998 99 86.3998L95.9 68.7998L80.3 77.2998Z'
          fill='#B8DD82'
        />
        <path
          d='M60.2 97.7997L66.5 91.4997C66.5 91.4997 70.5 91.7997 74.9 89.6997L66.9 97.6997C66.9 97.6997 64.3 98.3997 60.2 97.7997Z'
          fill='#EFFFB7'
        />
        <path
          d='M68.1 97.7998L77.4 88.4998C77.4 88.4998 79 87.6998 80 86.7998L69.4 97.2998C69.4 97.2998 68.7 97.6998 68.1 97.7998Z'
          fill='#EFFFB7'
        />
      </g>
      <defs>
        <clipPath id='clip0_703_5643'>
          <rect
            width='96'
            height='96'
            fill='white'
            transform='translate(16 16)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ActiveBankAccount;
